import { render, staticRenderFns } from "./ai-input.vue?vue&type=template&id=48afb9f8&lang=html"
import script from "./ai-input.vue?vue&type=script&lang=js"
export * from "./ai-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports